<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
        <el-button size="mini" type="primary" plain @click="exportSt" v-if="!isMB&&$permission.can('导出')">导出</el-button>
        <template v-if="$permission.canWrite()">
          <el-button size="mini" type="success" plain @click="improtSt" v-if="!isMB">导入</el-button>
          <el-button size="mini" type="warning" plain @click="improtStPic" v-if="!isMB">导入图片</el-button>
          <el-button size="mini" type="primary" plain @click="toFaceSwitch" v-if="$permission.can('家长人脸')">家长人脸</el-button>
          <el-button size="mini" type="primary" @click="create" icon="el-icon-plus">添加</el-button>
          <el-button size="mini" type="danger" @click="delRows">删除</el-button>
        </template>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" :width="$permission.can('家长人脸')?160:100">
          <template slot-scope="{row}">
            <el-button type="text" @click="edit(row)">编辑</el-button>
            <el-button type="text" @click="edit2(row)">改卡号</el-button>
            <el-button type="text" @click="edit3(row)" v-if="$permission.can('家长人脸')">家长人脸</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <card-dialog ref="cardDialog" @close-saved="reload" />
    <face-dialog ref="faceDialog" @close-saved="reload" />
    <face-switch ref="faceSwitch" @close-saved="reload" />
    <import-dialog ref="importDialog" @upload-success="reload" />
    <import-pic-dialog ref="importPicDialog" @upload-success="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/st/student/list";
import editDialog from "@/components/st/student/editDialog";
import cardDialog from "@/components/st/student/cardDialog";
import faceDialog from "@/components/st/student/faceDialog";
import faceSwitch from "@/components/st/student/faceSwitch";
import importDialog from "@/components/st/student/importDialog";
import importPicDialog from "@/components/st/student/importPicDialog";

export default {
  name: "student",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    cardDialog,
    faceDialog,
    faceSwitch,
    importDialog,
    importPicDialog,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    edit2(row) {
      this.$refs.cardDialog.openEdit(row);
    },
    edit3(row) {
      this.$refs.faceDialog.openEdit(row);
    },
    improtSt() {
      this.$refs.importDialog.open();
    },
    exportSt() {
      this.$refs.list.export();
    },
    improtStPic() {
      this.$refs.importPicDialog.open();
    },
    toFaceSwitch() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要设置的数据");
        return;
      }
      let Ids = rows.map((item) => {
        return item.StudentId;
      });
      this.$refs.faceSwitch.openCreate({ Ids });
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.StudentId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
.info-box {
  display: flex;
  display: -webkit-flex;
  display: -webkit-inline-flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
}
</style>